












import { mapGetters } from 'vuex'

// Services
import { ApiService, UserService } from '@/services'

export default {
  name: 'Personal',

  data() {
    return {
      saveSocialTagsLoading: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },

  methods: {
    saveSocialTags() {
      this.saveSocialTagsLoading = true
      const instagram_handle = this.user.instagram_handle ? this.user.instagram_handle.trim() : ''

      UserService.setSocialTags(instagram_handle).then(() => {
        this.saveSocialTagsLoading = false
        this.$toast.success('Social media username saved')
      })
    },
  },
}
